import React from "react";

const AppointmnetsSVG = ({ activeSvgColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49522 5.86616H19.5517M7.20928 1.10475V5.73284M13.8376 1.10475V5.30431M20.0469 7.66597V13.3797C20.0469 13.5892 20.0469 13.7987 20.0278 13.9986C19.6279 13.5058 19.1226 13.1088 18.5491 12.8369C17.9756 12.565 17.3484 12.425 16.7137 12.4274C15.7042 12.4274 14.7709 12.7797 14.0376 13.3701C13.5333 13.7687 13.1263 14.2767 12.8474 14.8558C12.5686 15.4349 12.4252 16.0699 12.4281 16.7127C12.4296 17.3476 12.5722 17.9744 12.8456 18.5475C13.1191 19.1206 13.5164 19.6258 14.009 20.0266C13.809 20.0456 13.5995 20.0456 13.3805 20.0456H7.66641C2.90469 20.0456 1 18.1411 1 13.3797V7.66597C1 2.90456 2.90469 1 7.66641 1H13.3805C18.1422 1 20.0469 2.90456 20.0469 7.66597Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0008 16.715C20.9995 17.3249 20.868 17.9276 20.6151 18.4827C20.3622 19.0378 19.9936 19.5324 19.5342 19.9337C18.7818 20.6003 17.8009 21.0002 16.7152 21.0002C15.6962 21.0002 14.7534 20.6384 14.0201 20.0289H14.0106C13.518 19.6281 13.1206 19.1229 12.8472 18.5498C12.5738 17.9767 12.4312 17.35 12.4297 16.715C12.4297 15.3627 13.0487 14.1533 14.0391 13.3724C14.7971 12.7614 15.7416 12.4287 16.7152 12.4297C18.058 12.4297 19.2485 13.0391 20.0294 14.001C20.6389 14.7342 21.0008 15.6865 21.0008 16.715Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0479 16.7118L16.105 17.7689L18.3906 15.6548"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AppointmnetsSVG;
